import React , { FC } from 'react';
import './footer.scss';

type Props = {
  rest : any
}

export const Footer : FC<Props> = ({ ...rest }) => {
  return <footer className={'footer'} {...rest} />;
};
